/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-24 09:10:56
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-17 16:06:24
 * @FilePath: \hlweb2.0\src\language\zh.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

const home = {
  banner1: "上海惠联办公设备有限公司",
  banner2: "您身边的办公服务专家",
  anchorPoint1: "惠联简介",
  anchorPoint1Con: {
    detail: "",
    title: "公司简介",
    content: {
      title: "关于惠联办公",
      list: [
        "上海惠联办公设备有限公司于1999年成立，是一家专业从事企业办公效率提升和办公成本控制的方案提供商，是具有深厚工程技术根底和高标准服务水平的公司。",
        "公司是科技型中小型企业、国家高新技术企业、专精特新企业、重点服务业企业，自主研发了多套关于办公信息化管理软件（已获软件著作权登记50多个）。",
        "公司从事办公资产全生命周期管理 、档案数字化、办公智能化、办公智慧空间和办公驻场服务。",
      ],
    },
    footList: [
      {
        top: "20年+",
        con: "行业经验",
      },
      { top: "1000+", con: "企业客户" },
    ],
  },
  anchorPoint2: "发展历程",
  anchorPoint2Con: {
    detail:
      "二十余年来，我们始终坚持创新与高标准服务并重，不断突破自我，追求卓越，与客户共同成长",
    imgUrl: require("../assets/images/home/developzh.png").default,
  },
  anchorPoint3: "企业文化",
  anchorPoint3Con: {
    detail:
      "我们的文化价值观是公司发展的基石，指引着我们的行为方式和决策原则，塑造了独特的企业文化",
    contentList: [
      {
        tit: "客户至上",
        con: "始终以客户需求为中心，致力于为您提供超预期的极致服务与体验",
      },
      {
        tit: "专业为本",
        con: "秉持匠心精神，以深厚的技术积淀与严谨的标准，交付值得信赖的产品和服务",
      },
      {
        tit: "持续创新",
        con: "积极拥抱技术与理念的变革，通过不断自我革新，为您创造长期价值与竞争力",
      },
      {
        tit: "合作共赢",
        con: "视客户为并肩前行的伙伴，力求在每一次合作中实现共同成长与价值共享",
      },
    ],
    footList: [
      {
        tit: "使命",
        con: "为企业提供高效、节能、智能的办公成本控制解决方案，助力客户实现降本增效",
      },
      {
        tit: "愿景",
        con: "成为办公行业数字化转型方案引领者",
      },
      {
        tit: "价值观",
        con: "以诚信协作奠定根基，以创新思维突破边界，以高效执行实现承诺，与客户共赢成就未来",
      },
    ],
  },
  anchorPoint4: "产品与服务",
  anchorPoint4Con: {
    titleColor: "惠联",
    title: "能为您做什么",
    detail:
      "我们提供全方位的数字化解决方案，助力企业实现数字化转型，提升核心竞争力 无论是标准化产品还是定制化服务，我们都能满足您的需求",
  },
  anchorPoint5: "文化活动",
};
const productList = [
  {
    title: "档案数字化服务",
    imgUrl: require("../assets/images/productList1.png").default,
    con1: "惠联档案一体化智能服务平台",
    con2: "数字档案管理",
    con3: "高效、智能、安全的档案管理解决方案",
    con3List:["高效、智能、安全的档案管理解决方案"],
    jump: "了解更多",
    jumpLine: "/solution/archives",
    linked: "立即体验",
  },
  {
    title: "档案信息化产品",
    imgUrl: require("../assets/images/productList2.png").default,
    con1: "惠联数智化档案一档档享®",
    con2: "智能档案信息化管理平台",
    con3: "实现档案“立、收、存、管、用、销” 全流程数字化管理 让档案数据活起来、用起来、享起来",
    con3List:["实现档案“立、收、存、管、用、销”","全流程数字化管理","让档案数据活起来、用起来、享起来"],
    jump: "了解更多",
    jumpLine: "/solution/infoServices",
    linked: "立即体验",
  },
  {
    title: "资产全生命周期管理",
    imgUrl: require("../assets/images/productList3.png").default,
    con1: "惠联一站式资产全生命周期管理",
    con2: "智能办公资产管理平台",
    con3: "从购置到处置，资产的“全生命周期数字化管理” 让每一份资产都物尽其用、物超所值",
    con3List:["从购置到处置，资产的“全生命周期数字化管理”","让每一份资产都物尽其用、物超所值"],
    jump: "了解更多",
    jumpLine: "/solution/asset",
    linked: "立即体验",
  },
  {
    title: "空间运营管理数智化",
    imgUrl: require("../assets/images/productList4.png").default,
    con1: "惠联智慧空间运营管理平台",
    con2: "空间运营管理数智化",
    con3: "打造畅行、可信、有温度的智慧空间体验",
    con3List:["打造畅行、可信、有温度的智慧空间体验"],
    jump: "了解更多",
    jumpLine: "/solution/spaceOperations",
    linked: "立即体验",
  },
  {
    title: "驻场服务",
    imgUrl: require("../assets/images/productList5.png").default,
    con1: "惠联专业IT技术人才解决方案",
    con2: "驻场服务平台",
    con3: "为企业提供全方位的IT人才服务，助力企业 数字化转型",
    con3List:["为企业提供全方位的IT人才服务","助力企业 数字化转型"],
    jump: "了解更多",
    jumpLine: "/solution/residency",
    linked: "获取专属IT驻场方案",
    linked2: "了解我们的团队",
  },
];

const navigation = {
  home: "网站首页",
  product: "产品服务",
  product1: "档案数字化服务",
  product2: "档案信息化产品",
  product3: "资产全生命周期管理",
  product4: "空间运营管理数智化",
  product5: "驻场服务",
  success: "成功案例",
  about: "联系我们",
  experience: "立即体验",
  experience_con: "现在开始尝试更简单高效的工作方式",
  footer1: "上海惠联",
  footer2: "网站首页",
  footer5Con: ["联系我们", "访问我们"],
  footer6: "立即体验",
  footer6Con1: [
    { til: "服务热线", con: "021-57186429" },
    { til: "联系邮箱", con: "huilian118@163.com" },
  ],
  footer6Con2: { til: "关注我们：", con1: "微信", con2: "惠联公众号" },
};
const solution_archives = {
  archives1: {
    til: "档案工作面临的问题与挑战",
    imgUrl: require("../assets/images/solution/archives/customized.png")
      .default,
    contentLeftList: [
      {
        title: "检索困境",
        conList: [
          "实体档案存储+手工管理的方式",
          "无法应对需要高速检索目标的需求",
        ],
      },
      {
        title: "规范缺失",
        conList: [
          "缺失相关立档规范和标准",
          "不知道要收哪些数据",
          "由谁做这些事",
        ],
      },
      {
        title: "人才匮乏",
        conList: ["专职档案管理人才稀缺", "信息化+业务+档案综合人才更缺"],
      },
    ],
    contentRightList: [
      {
        title: "信息孤岛",
        conList: ["信息化程度低", "档案数据利用率低"],
      },
      {
        title: "归档难题",
        conList: [
          "信息爆炸时代",
          "如何清洗筛选需要的数据进行归档",
          "以便于建立企业自主知识管理",
        ],
      },
      {
        title: "安全隐患",
        conList: ["应对安全、技术过时等风险", "确保电子档案长期可信、可用"],
      },
    ],
  },
  archives2: {
    til: "档案行业数字化转型",
    detail: "实现实体档案、电子档案、数据档案一体化管理的进阶",
    contentList: [
      {
        tit: "实体档案",
        imgUrl: require("../assets/images/solution/archives/industry1.png")
          .default,
        icon1:
          require("../assets/images/solution/archives/industry_icon1_1.png")
            .default,
        icon2:
          require("../assets/images/solution/archives/industry_icon1_2.png")
            .default,
        detail: "传统纸质文件、合同、文档、图纸等实体档案的数字化处理",
        list: ["实体采集", "数据标引", "分级存储", "影像检索"],
      },
      {
        tit: "电子档案",
        imgUrl: require("../assets/images/solution/archives/industry2.png")
          .default,
        icon1:
          require("../assets/images/solution/archives/industry_icon2_1.png")
            .default,
        icon2:
          require("../assets/images/solution/archives/industry_icon2_2.png")
            .default,
        detail: "已有电子文档的规范化管理，包括格式转换、元数据添加和分类整理",
        list: ["格式规范", "长期可用", "有序管控", "知识赋能"],
      },
      {
        tit: "数据档案",
        imgUrl: require("../assets/images/solution/archives/industry3.png")
          .default,
        icon1:
          require("../assets/images/solution/archives/industry_icon3_1.png")
            .default,
        icon2:
          require("../assets/images/solution/archives/industry_icon3_2.png")
            .default,
        detail: "结构化数据的整合管理，包括数据库、表格和业务系统数据的归档",
        list: ["海量汇聚", "深度整序", "可信存证", "决策支持"],
      },
    ],
  },
  archives3: {
    til: "内外协同·智能高效·实现数智化",
    detail:
      "提供全方位的档案数字化服务，帮助您实现档案管理的标准化、数字化、数据化和数智化",
    contentList: [
      {
        tit: "咨询服务",
        imgUrl: require("../assets/images/solution/archives/industry4.png")
          .default,
        detail:
          "提供专业的档案数字化咨询服务，包括需求分析、方案设计和实施规划",
        list: ["需求分析", "方案设计", "实施规划", "技术支持"],
      },
      {
        tit: "软件服务",
        imgUrl: require("../assets/images/solution/archives/industry5.png")
          .default,
        detail: "提供档案管理系统软件，支持定制化开发和系统集成",
        list: ["系统开发", "定制化配置", "系统集成", "技术支持"],
      },
      {
        tit: "拓展服务",
        imgUrl: require("../assets/images/solution/archives/industry6.png")
          .default,
        detail: "提供档案管理系统的功能拓展和升级服务，满足业务发展需求",
        list: ["功能拓展", "系统升级", "接口开发", "数据迁移"],
      },
    ],
  },
  archives4: {
    til: "为什么选择我们",
    contentList: [
      {
        tit: "专业资质",
        imgUrl: require("../assets/images/solution/archives/carousel1.png")
          .default,
        detailList: ["拥有多项专业资质"],
      },
      {
        tit: "技术实力",
        imgUrl: require("../assets/images/solution/archives/carousel2.png")
          .default,
        detailList: ["技术团队平均经验丰富"],
      },
      {
        tit: "项目经验",
        imgUrl: require("../assets/images/solution/archives/carousel3.png")
          .default,
        detailList: ["成功交付档案项目超过1000+", "客户满意度100%"],
      },
      {
        tit: "安全保密",
        imgUrl: require("../assets/images/solution/archives/carousel4.png")
          .default,
        detailList: ["严格执行国家保密法规", "建立完善的安全保密制度"],
      },
      {
        tit: "全程服务",
        imgUrl: require("../assets/images/solution/archives/carousel5.png")
          .default,
        detailList: ["提供一站式服务"],
      },
      {
        tit: "专业资质",
        imgUrl: require("../assets/images/solution/archives/carousel1.png")
          .default,
        detailList: ["拥有多项专业资质"],
      },
      {
        tit: "技术实力",
        imgUrl: require("../assets/images/solution/archives/carousel2.png")
          .default,
        detailList: ["技术团队平均经验丰富"],
      },
      {
        tit: "项目经验",
        imgUrl: require("../assets/images/solution/archives/carousel3.png")
          .default,
        detailList: ["成功交付档案项目超过1000+", "客户满意度100%"],
      },
      {
        tit: "安全保密",
        imgUrl: require("../assets/images/solution/archives/carousel4.png")
          .default,
        detailList: ["严格执行国家保密法规", "建立完善的安全保密制度"],
      },
      {
        tit: "全程服务",
        imgUrl: require("../assets/images/solution/archives/carousel5.png")
          .default,
        detailList: ["提供一站式服务"],
      },
    ],
  },
  archives5: {
    til: "让不同行业找到更适合自己的协同方式",
    case1: "查看案例",
    case2: "客户案例",
    case1Url: require("../assets/images/solution/archives/case.png").default,
  },
};
const spaceOperations = {
  space_part2: {
    title: "您的空间运营是否正面临这些挑战",
    spact_partList: [
      {
        itemTitle: "重建设、轻运营",
        itemContent: "缺乏整体规划，系统碎片化",
      },
      {
        itemTitle: "数据孤岛",
        itemContent: "通行、安防、能耗等系统彼此孤立，协同效率低",
      },
      {
        itemTitle: "管理成本高",
        itemContent: "依赖大量人工，运营成本难以控制",
      },
      {
        itemTitle: "体验感缺失",
        itemContent: "员工、访客缺乏便捷、智能、有温度的空间体验",
      },
    ],
    dotColor: "#008AD4",
  },
  space_part3: {
    title: "五大核心模块",
    subhead: "全方位覆盖空间运营管理需求，打造智能化、人性化的企业空间体验",
    space_part3List: [
      {
        itemTitle: "空间安行",
        itemContent:
          "构筑畅行和安防每一个空间、每一个角落的企业数智通行和安防解决方案",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part1.png")
            .default,
        type: "first",
      },
      {
        itemTitle: "空间协同",
        itemContent:
          "提升企业空间资源利用效率，实现会议室、工位等资源的智能预约与高效协同     ",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part2.png")
            .default,
        type: "second",
      },
      {
        itemTitle: "空间沟通",
        itemContent:
          "打造企业内部信息发布与沟通平台，实现信息精准触达与高效流转",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part3.png")
            .default,
        type: "third",
      },
      {
        itemTitle: "空间传播",
        itemContent:
          "构建企业品牌形象展示与文化传播体系，提升品牌价值与文化认同",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part4.png")
            .default,
        type: "fourth",
      },
      {
        itemTitle: "空间孪生",
        itemContent:
          "构建物理空间的数字镜像，实现空间全要素数字化管理与可视化运营",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part5.png")
            .default,
        type: "fifth",
      },
    ],
    learn_more: "了解更多",
  },
  space_part4: {
    title: "选择惠联空间运营的三大理由",
    spact_partList: [
      {
        itemTitle: "一体化平台",
        itemContent: "打破系统孤岛，一个平台覆盖全场景，降低集成与运维复杂度",
      },
      {
        itemTitle: "极致用户体验",
        itemContent: "引入ITIL等最佳实践，服务流程标准化，交付质量有保障",
      },
      {
        itemTitle: "数据驱动价值",
        itemContent:
          "深入运营数据，助力节能降耗、提质增效，实现精细化、精益化管理",
      },
    ],
    dotColor: "rgba(0, 138, 212, 0.12)",
  },
  space_part5: {
    title: "多元应用场景",
    subhead: "数智化解决方案，赋能各类空间实现高效运营管理",
    space_partList: [
      {
        itemTitle: "办公空间",
        itemContent:
          "提升办公环境舒适度与工作效率，打造智能高效的现代化办公体验",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part6.png")
            .default,
      },
      {
        itemTitle: "商业综合体",
        itemContent: "优化人流引导与商户布局，提升顾客体验与商业价值",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part7.png")
            .default,
      },
      {
        itemTitle: "产业园区",
        itemContent: "整合园区资源，实现跨企业协同，提升园区整体运营效率",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part8.png")
            .default,
      },
    ],
  },
  KernelModule: {
    nav: {
      title: "解决方案导航",
      titleIcon: require("../assets/images/solution/kernelModulePage/icon3.png")
        .default,
      list: [
        {
          label: "空间安行",
          value: "first",
        },
        {
          label: "空间协同",
          value: "second",
        },
        {
          label: "空间沟通",
          value: "third",
        },
        {
          label: "空间传播",
          value: "fourth",
        },
        {
          label: "空间孪生",
          value: "fifth",
        },
      ],
      footer: "联系我们获取方案详情",
      onLine: "立即体验",
    },
    first: {
      introduce:
        '构建物理空间的数字镜像，实现空间全要素数字化管理与可视化运营。作为所有解决方案的"数字底座"和"智慧大脑"，空间孪生平台打通空间"人、事、物、场"全要素，为企业提供一站式空间运营管理数智化解决方案。',
      imgUrl: require("../assets/images/solution/kernelModulePage/first.png")
        .default,
      list_one: [
        {
          title: "数智通行",
          content:
            "人脸识别、一码通、车辆管理，实现无感、高效、有序的通行体验。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "数智访客",
          content: "线上预约、自助终端、权限联动，提升访客体验与安保效率。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "安全预警",
          content: "电子围栏、视频AI分析、智能巡更，实现主动式安全防范。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "提升安全等级：多重智能安防手段，实现全方位安全防护",
        "降低安保人力成本：智能化管理减少人工干预，优化人力资源配置",
        "提升通行效率与体验：无感通行，减少等待时间，提升员工满意度",
        "数据化管理决策：通行数据统计分析，为管理优化提供数据支持",
      ],
      list_three: [
        {
          title: "园区主入口",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "楼宇大厅",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "重要通道",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "办公室门禁",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: ["智能人脸识别闸机", "自助访客终端", "智能门禁面板"],
    },
    second: {
      introduce:
        "提升企业空间资源利用效率，实现会议室、工位等资源的智能预约与高效协同。通过数字化手段优化空间资源配置，提高空间利用率，降低运营成本，为员工创造更加灵活、高效的工作环境。",
      imgUrl: require("../assets/images/solution/kernelModulePage/second.png")
        .default,
      list_one: [
        {
          title: "智能空间预约",
          content:
            "会议室、工位、洽谈区等空间资源的在线查询、预订与管理，支持多终端同步。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "环境智能调控",
          content:
            "温度、湿度、照明、空调等环境设备的智能联动与远程控制，打造舒适办公环境。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "空间数据分析",
          content:
            "空间使用率、预订率、满意度等数据的统计分析，为空间优化提供决策支持。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "提高空间利用率：智能预约系统减少资源闲置，提升空间使用效率",
        "降低运营成本：优化空间配置，减少无效空间占用，降低租金与维护成本",
        "提升工作效率：便捷的空间预约与环境控制，减少行政事务时间成本",
        "优化办公体验：舒适的环境与灵活的空间选择，提升员工满意度与创造力",
      ],
      list_three: [
        {
          title: "会议室",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "开放工位",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "洽谈区",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "休闲空间",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: ["智能会议室预订屏", "环境控制面板", "空间数据分析平台"],
    },
    third: {
      introduce:
        "打造企业内部信息发布与沟通平台，实现信息精准触达与高效流转。通过多终端协同与智能推送，确保重要信息及时传递，促进组织内部高效沟通与协作。",
      imgUrl: require("../assets/images/solution/kernelModulePage/third.jpg")
        .default,
      list_one: [
        {
          title: "智能信息发布",
          content:
            "企业公告、通知、活动等信息的精准发布与推送，支持多终端同步展示。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "即时通讯集成",
          content:
            "与企业IM系统无缝集成，支持消息推送、快速回复与群聊功能，促进团队沟通。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "智能问答助手",
          content: "AI驱动的智能问答系统，解答员工常见问题，提供自助服务支持。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "提升信息传递效率：确保重要信息及时、准确地传递给目标人群",
        "降低沟通成本：减少会议、邮件等传统沟通方式，提高沟通效率",
        "增强组织协作：打破部门壁垒，促进跨部门信息共享与协作",
        "提升员工满意度：便捷的信息获取与沟通方式，改善员工体验",
      ],
      list_three: [
        {
          title: "企业公告",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "部门通知",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "员工问答",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "团队协作",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: ["信息发布终端", "智能问答终端", "沟通管理平台"],
    },
    fourth: {
      introduce:
        "构建企业品牌形象展示与文化传播体系，提升品牌价值与文化认同。通过数字化媒体网络与智能内容管理，实现品牌信息精准传播与企业文化有效渗透。",
      imgUrl: require("../assets/images/solution/kernelModulePage/fourth.jpg")
        .default,
      list_one: [
        {
          title: "数字标牌网络",
          content:
            "企业内部与外部空间的数字标牌网络，支持高清视频、图片、文字等多媒体内容展示。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "内容管理系统",
          content:
            "集中式内容创作、审核与发布平台，支持远程更新与精准投放，确保内容时效性。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "传播效果分析",
          content:
            "内容浏览量、停留时间、互动率等数据的统计分析，评估传播效果与优化策略。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "提升品牌形象：统一、专业的视觉形象展示，增强品牌认知度",
        "强化文化认同：企业文化的可视化传播，增强员工归属感与认同感",
        "提高信息触达率：多样化的展示终端与精准投放，确保信息有效触达",
        "降低传播成本：数字化内容管理与发布，减少印刷物料与人工成本",
      ],
      list_three: [
        {
          title: "大堂展示",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "电梯间",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "会议室",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "办公区域",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: ["高清数字标牌", "透明展示屏", "内容管理平台"],
    },
    fifth: {
      introduce: `构建物理空间的数字镜像，实现空间全要素数字化管理与可视化运营。作为所有解决方案的"数字底座"和"智慧大脑"，空间孪生平台打通空间"人、事、物、场"全要素，为企业提供一站式空间运营管理数智化解决方案。`,
      imgUrl: require("../assets/images/solution/kernelModulePage/fifth.jpg")
        .default,
      list_one: [
        {
          title: "三维空间建模",
          content:
            "高精度物理空间三维建模，还原真实空间布局与细节，构建数字孪生体。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "实时数据同步",
          content:
            "空间设备、环境、人员等实时数据采集与同步，实现物理空间与数字空间的联动。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "数据可视化分析",
          content:
            "多维度数据可视化展示与深度分析，支持空间运营状态实时监控与决策支持。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "智能决策支持",
          content:
            "AI驱动的空间运营优化建议与智能决策支持，实现空间管理的精细化与精益化。",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "一站式运营平台：整合所有空间管理功能，提供统一操作界面，降低管理复杂度",
        "全生命周期管理：覆盖空间规划、建设、运营、优化全流程，实现闭环管理",
        "数据可视化：复杂空间数据直观展示，提升管理效率与决策准确性",
        `从"行为流"到"成本流"：全面分析空间使用行为与成本数据，优化资源配置与成本控制`,
      ],
      list_three: [
        {
          title: "园区管理",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "楼宇运营",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "办公空间",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "智慧展厅",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: ["孪生建模引擎", "数据集成平台", "可视化决策中心"],
    },
  },
};

const solution_infoServices = {
  infoServices1: {
    back: "#f0f9fd",
    til: "档档享® · 档案数字化转型全周期管理",
    dil: "从标准建立到合规销毁，全方位覆盖档案管理生命周期，提供安全、高效、智能的档案信息化解决方案",
    imgUrl: require("../assets/images/solution/infoServices/customized.png")
      .default,
    width: "900px", //图片宽度
  },
  infoServices2: {
    til: "档档享® · 享受数据档案带给您的未来",
    dil: "",
    contractList: [
      {
        title: "全流程功能覆盖",
        detail: "档案管理各环节无缝衔接",
        list: [
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_1.png")
                .default,
            text: "文件材料审核与价值鉴定",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_2.png")
                .default,
            text: "智能立卷与组件管理",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_3.png")
                .default,
            text: "案卷备考表入库与归档",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_4.png")
                .default,
            text: "档案上架与位置管理",
          },
        ],
      },
      {
        title: "全方位安全权限保障",
        detail: "全方位保障档案信息安全",
        list: [
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_1.png")
                .default,
            text: "三员分立权限管理",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_2.png")
                .default,
            text: "四性检测",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_3.png")
                .default,
            text: "国密算法集成与数字水印技术",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_4.png")
                .default,
            text: "操作日志全记录与审计追踪",
          },
        ],
      },
      {
        title: "未来知识体系",
        detail: "智能化技术驱动档案管理革新",
        list: [
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future3_1.png")
                .default,
            text: "分布式数据分析引擎",
            detail: "检索速度快、规模广",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future3_2.png")
                .default,
            text: "国产大模型解析识别",
            detail: "填补非结构化数据检索空白",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future3_3.png")
                .default,
            text: "低代码平台",
            detail: "拖拽式组件实现快速配置",
          },
        ],
      },
    ],
  },
  infoServices3: {
    til: "档档享® · 核心内容",
    dil: "六大产品体系，全方位覆盖档案管理各环节需求，提供完整解决方案",
    jumpText: "立即体验",
    learnMore: "了解更多",
    contractList: [
      {
        label: "数据采集",
        title: "档案数字化采集系统",
        text: "多源数据采集与数字化加工处理",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate1.png")
            .default,
        list: [
          "多格式文件自动识别与采集",
          "纸质档案高速扫描与OCR识别",
          "元数据智能提取与著录",
          "批量处理与质量审核",
        ],
      },
      {
        label: "核心平台",
        title: "档案数字化管理系统",
        text: "核心档案管理平台，实现档案全生命周期管理",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate2.png")
            .default,
        list: [
          "符合国家档案管理标准规范",
          "电子档案与实体档案一体化管理",
          "全流程规范化业务处理",
          "智能检索与快速定位",
        ],
      },
      {
        label: "实体管理",
        title: "IOT库房管理系统",
        text: "智能库房环境监控与实体档案管理",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate3.png")
            .default,
        list: [
          "温湿度实时监控与预警",
          "档案定位与智能上架",
          "安防监控与异常报警",
          "设备联动与自动化控制",
        ],
      },
      {
        label: "应用服务",
        title: "档案数字化借阅系统",
        text: "线上查借阅与利用管理",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate4.png")
            .default,
        list: [
          "智能检索与精准定位",
          "线上借阅申请与审批流程",
          "电子文件在线预览",
          "借阅跟踪与归还提醒",
        ],
      },
      {
        label: "数据分析",
        title: "档案数字化分析平台",
        text: "档案数据挖掘与知识发现",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate5.png")
            .default,
        list: [
          "档案数据多维度分析",
          "知识图谱构建与展示",
          "热点问题智能发现",
          "决策支持与趋势预测",
        ],
      },
      {
        label: "高级应用",
        title: "档案数据挖掘平台",
        text: "大数据分析与可视化展示",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate6.png")
            .default,
        list: [
          "海量档案数据处理引擎",
          "自定义报表与可视化仪表盘",
          "数据资产化与价值评估",
          "行业知识库构建",
        ],
      },
    ],
  },
  infoServices4: {
    til: "专注为不同企业提供专业解决方案",
    dil: "针对不同行业特点与需求，提供定制化档案信息化解决方案，解决行业特定痛点",
    title2: "解决方案特点",
    icon: require("../assets/images/solution/infoServices/carousel1.png")
      .default,
    icon2: require("../assets/images/solution/infoServices/icon2.png").default,
    contractList: [
      {
        title: "政府机关",
        detail: "档案数量庞大、类型多样、保密要求高、查阅频繁",
        label: "提升政务效率，保障信息安全，实现阳光政务",
        list: [
          "分级权限管理与操作审计",
          "跨部门档案共享协作平台",
          "电子签章与公文流转一体化",
          "历史档案数字化与长期保存",
        ],
      },
      {
        title: "金融行业",
        detail: "档案数量庞大、类型多样、保密性与时效性要求极高，合规风险突出",
        label: "保障信息安全与合规性，提升风控能力与运营效率，降低管理成本",
        list: ["智能化仓储", "自动化管理", "快速调阅", "安全存储"],
      },
      {
        title: "教育行业",
        detail: "学员信息分散、成长轨迹记录需求高、隐私保护要求严",
        label:
          "提升管理效率与家校沟通体验，保障学生隐私，数据支撑个性化教学与科学决策",
        list: [
          "学员档案数字化管理",
          "权限分级（访问权限不同）",
          "报名、排课、考勤一体化",
        ],
      },
      {
        title: "医疗行业",
        detail: "包含大量患者隐私、安全性要求极高，精准检索需求强",
        label: "保护患者隐私，提升诊疗效率与安全性，为临床诊断和科研提供支持",
        list: ["严格权限管理", "先进加密技术", "精准检索功能"],
      },
      {
        title: "司法行业",
        detail:
          "律师业务活动的真实记录，国家重要专业档案，涉及大量敏感信息和机密，查阅调阅需严格审批",
        label:
          "确保档案的完整与安全，为律师业务提供服务，遵守法规并保护客户机密",
        list: [
          "建立规范管理制度",
          "严格借阅与查阅审批",
          "档案鉴定与销毁流程",
          "安全防护措施",
        ],
      },
      {
        title: "国有企业",
        detail:
          "需严格符合国家档案管理法规及行业标准，业务流程复杂且多部门协同，海量历史档案需保存与挖掘价值",
        label:
          "确保合规性，提升流程协同效率，挖掘档案数据价值支持决策，传承企业历史与文化",
        list: [
          "合规性管理",
          "OA、ERP等业务系统深度集成",
          "数据分析与挖掘",
          "历史档案数字化",
        ],
      },
      {
        title: "大型装备行业",
        detail:
          "产品结构复杂、生命周期长、版本迭代多、精度要求高、质量追溯压力大、供应链协同复杂",
        label:
          "保障技术知识资产安全，提升设计与制造协同效率，实现全生命周期质量追溯，降低合规与售后风险",
        list: [
          "产品数据管理/产品生命周期管理集成",
          "严格的版本控制与变更流程追溯",
          "供应链外协单位权限管理与协同平台",
          "大数据块（如三维模型）安全存储与高效传输",
          "与MES、QMS系统打通，实现全生命周期可追溯",
        ],
      },
      {
        title: "可适配、定制化专属服务",
        detail:
          "每个项目/客户档案独一无二，包含大量沟通记录、创意稿、设计源文件；版本易混乱，客户需求多变需全程留痕；成本与报价管理复杂",
        label:
          "保护创意设计知识产权，避免版本错误导致损失，清晰追溯客户需求变更，提升客户体验与复购率，为类似项目提供数据参考",
        list: [
          "以“客户项目”为主线的档案组织模式",
          "设计稿/源代码的版本管理",
          "客户沟通记录与需求变更追溯",
          "成本核算与报价文件关联管理",
          "成品照片与客户验收资料归档",
        ],
      },
    ],
  },
  infoServices5: {
    name: "核心技术",
    back: "#f0f9fd",
    dil: "融合前沿技术与创新理念，为档案信息化提供强大技术支撑",
    contractList: [
      {
        name: "一键检索",
        imgUrl: require("../assets/images/solution/infoServices/advantage1.png")
          .default,
      },
      {
        name: "智能辅助",
        imgUrl: require("../assets/images/solution/infoServices/advantage2.png")
          .default,
      },
      {
        name: "文档解析",
        imgUrl: require("../assets/images/solution/infoServices/advantage3.png")
          .default,
      },
      {
        name: "数据加密",
        imgUrl: require("../assets/images/solution/infoServices/advantage4.png")
          .default,
      },
    ],
  },
  infoServices6: {
    til: "强大技术实力，保障卓越产品体验",
    dil: "拥有一支由AI算法专家、档案管理专家和软件工程师组成的专业团队，持续创新与技术突破， 为客户提供稳定可靠、安全高效的档案信息化解决方案",
    contractList: [
      {
        num: "50+",
        detail: "技术专利与软件著作权",
      },
      {
        num: "100%",
        detail: "系统稳定性保障",
      },
      {
        num: "50万+",
        detail: "日均档案处理能力",
      },
      {
        num: "24小时在线",
        detail: "专业技术支持服务",
      },
    ],
  },
};
const residency = {
  space_part2: {
    title: "核心服务",
    list_one: [
      {
        iconUrl: require("../assets/images/solution/residency/part1.png")
          .default,
        iconUrl2:
          require("../assets/images/solution/residency/part1_active.png")
            .default,
        title: "办公设备运维",
        id: 1,
      },
      {
        iconUrl: require("../assets/images/solution/residency/part2.png")
          .default,
        iconUrl2:
          require("../assets/images/solution/residency/part2_active.png")
            .default,
        title: "IT基础设施驻场",
        id: 2,
      },
      {
        iconUrl: require("../assets/images/solution/residency/part3.png")
          .default,
        iconUrl2:
          require("../assets/images/solution/residency/part3_active.png")
            .default,
        title: "软件开发与测试驻场",
        id: 3,
      },
    ],
    list_two: [
      {
        title: "智能办公设备运维",
        subhead:
          "专注于硬件设备的维护与管理，确保您的办公设备始终处于最佳运行状态，减少故障停机时间，提高工作效率。",
        imgUrl: require("../assets/images/solution/residency/part1_img.png")
          .default,
        list_two_list: [
          "台式机、笔记本电脑的日常维护与故障排除",
          "打印机、复印机等办公外设的安装与调试",
          "办公设备的定期巡检与预防性维护",
          "设备驱动程序与软件的安装配置",
        ],
        dot: require("../assets/images/solution/residency/yesicon.png").default,
      },
      {
        title: "IT基础设施驻场",
        subhead:
          "涵盖驻场IT工程师、桌面工程师和网络工程师的全方位服务，确保您的IT基础设施稳定可靠运行。",
        imgUrl: require("../assets/images/solution/residency/part2_img.png")
          .default,
        list_two_list: [
          "驻场IT工程师：服务器、存储设备的日常维护 ",
          "桌面工程师：终端设备与用户支持服务",
          "网络工程师：网络设备配置与性能优化",
          "基础设施监控与故障预警系统实施",
        ],
        dot: require("../assets/images/solution/residency/yesicon.png").default,
      },
      {
        title: "软件开发与测试驻场",
        subhead:
          "派驻专业的开发与测试工程师，无缝融入您的团队，提供高质量的软件开发与测试服务，加速产品迭代与交付。",
        imgUrl: require("../assets/images/solution/residency/part3_img.png")
          .default,
        list_two_list: [
          "驻场开发工程师：根据需求进行软件项目开发与维护",
          "驻场测试工程师：功能测试、性能测试与兼容性测试",
          "支持多种技术栈：Java、前端、PHP等",
          "敏捷开发流程支持，快速响应业务需求变化",
        ],
        dot: require("../assets/images/solution/residency/yesicon.png").default,
      },
    ],
  },
  space_part3: {
    title: "我们的优势",
    list: [
      {
        itemTitle: "人才矩阵",
        itemContent:
          "拥有覆盖硬件、网络、系统、开发、测试的全岗位技术人才库，精准匹配项目需求。",
        iconUrl: require("../assets/images/solution/residency/part4.png")
          .default,
      },
      {
        itemTitle: "流程标准",
        itemContent: "引入ITIL等最佳实践，服务流程标准化，交付质量有保障。",
        iconUrl: require("../assets/images/solution/residency/part5.png")
          .default,
      },
      {
        itemTitle: "安全合规",
        itemContent:
          "驻场人员签订严格保密协议，操作符合安全规范，为您的数据安全保驾护航。",
        iconUrl: require("../assets/images/solution/residency/part6.png")
          .default,
      },
    ],
  },
  space_part4: {
    introduceTitle: "驻场服务",
    introduceContent:
      "专业的驻场服务，按需定制，专人专岗，为您的业务提供全方位技术支持",
    title: "服务模式",
    list: [
      {
        itemTitle: "按需定制",
        itemContent:
          "根据您的业务需求和预算，灵活定制驻场服务方案，确保资源投入最优化。",
        iconUrl: require("../assets/images/solution/residency/part7.png")
          .default,
      },
      {
        itemTitle: "专人专岗",
        itemContent:
          "为您匹配经验丰富的专业人才，专注于特定岗位需求，深入理解业务场景。",
        iconUrl: require("../assets/images/solution/residency/part8.png")
          .default,
      },
      {
        itemTitle: "团队入驻",
        itemContent:
          "提供完整的技术团队驻场支持，从项目规划到实施落地，全程保驾护航。",
        iconUrl: require("../assets/images/solution/residency/part9.png")
          .default,
      },
    ],
    otherInfo: {
      title: "灵活的合作方式",
      content:
        "无论是短期项目支持还是长期驻场服务，我们都能提供灵活的合作模式，根据您的业务周期和项目需求进行调整，确保服务质量的同时最大限度降低成本。",
      btnText: "联系我们",
    },
  },
  space_part5: {
    introduceTitle: "解决企业困境",
    introduceContent:
      "专业IT驻场服务，有效破解企业人才管理难题，降低成本与风险",
    first: {
      title: '企业面临的"三难两高"挑战',
      describe:
        "在IT人才管理过程中，企业普遍面临招聘、培养、保留人才的困难，以及成本和风险居高不下的挑战",
      list: [
        {
          itemTitle: "招人难",
          itemContent:
            "招聘流程繁杂，评价标准较严苛，竞争压力大，难招到优秀人才",
        },
        {
          itemTitle: "育人难",
          itemContent: "培养人才资源投入大，个性化培养难，人才培养困难",
        },
        {
          itemTitle: "留人难",
          itemContent:
            "晋升通道相对狭窄，对职业前景感到迷茫，难清晰勾勒未来发展方向",
        },
        {
          itemTitle: "风险高",
          itemContent: "人员优化易引发纠纷，法律法规严格，用工风险防控难 ",
        },
        {
          itemTitle: "成本高",
          itemContent: "薪酬福利体系复杂，社会保障负担重，人工成本居高不下",
        },
      ],
    },
    second: {
      title: "全方位实施策略",
      describe:
        "针对企业面临的人才管理挑战，我们提供系统化解决方案，帮助企业突破困境      ",
      list: [
        {
          itemTitle: "人才招聘与筛选",
          list: ["拓展多元化招聘渠道", "精准化人才筛选策略"],
        },
        {
          itemTitle: "人才培养与发展",
          list: ["系统化培训体系", "人才提升计划"],
        },
        {
          itemTitle: "人才保留与激励",
          list: ["完善职业发展通道", "积极向上的企业文化"],
        },
        {
          itemTitle: "风险管控",
          list: ["法律风险管控", "数据安全管控", "人才管理风险应对"],
        },
        {
          itemTitle: "成本控制",
          list: ["人员管理阶段成本控制", "项目执行阶段成本控制"],
        },
      ],
    },
  },
  space_part6: {
    introduceTitle: "人才团队",
    introduceContent: "专业的技术团队是我们提供优质服务的核心保障",
    title: "人才理念",
    describe: `不仅提供人，更提供合格、稳定、高效的技术伙伴。我们通过严格的筛选流程选拔人才，持续的培训体系提升能力，科学的管理制度保障服务质量。`,
    list: [
      {
        itemTitle: "严格筛选",
        itemContent:
          "多轮技术面试和综合能力评估，确保候选人具备扎实的专业技能和良好的职业素养。",
        iconUrl: require("../assets/images/solution/residency/part10.png")
          .default,
      },
      {
        itemTitle: "持续培训",
        itemContent:
          "定期组织技术分享和技能培训，帮助工程师保持技术领先，提升解决复杂问题的能力。",
        iconUrl: require("../assets/images/solution/residency/part11.png")
          .default,
      },
      {
        itemTitle: "绩效管理",
        itemContent:
          "建立科学的绩效考核体系，激励工程师提供更优质的服务，实现个人与企业共同成长。",
        iconUrl: require("../assets/images/solution/residency/part12.png")
          .default,
      },
    ],
  },
};
const solution_asset = {
  asset1: [
    {
      num: "500+",
      detail: "服务企业",
    },
    {
      num: "20万+",
      detail: "管理资产",
    },
    {
      num: "50+",
      detail: "覆盖城市",
    },
    {
      num: "100%",
      detail: "客户满意度",
    },
  ],
  asset2: {
    title: "全面解决方案，覆盖资产管理全流程",
    detail:
      "从设备入库到处置，从报修到评价，从数据孤岛到全局互联，全方位数字化管理",
    content: {
      title: "资产全生命周期管理",
      detail:
        "应当针对固定资产的全生命周期进行系统化的管理，包括固定资产的购置、登记、领用、借用、调拨、盘点、维护、折旧、处置等全过程的管理。",
      imgUrl: require("../assets/images/solution/asset/lifeCycle.png").default,
      list: [
        {
          title: "资产入库与档案建立",
          detail: "为新增资产登记建档、赋予唯一身份码，建立数字化基础",
        },
        {
          title: "日常运营与维护",
          detail: "通过定期保养计划，预防故障发生，延长资产使用寿命",
        },
        {
          title: "维修管理",
          detail: "从报修到评价的在线化流程，确保故障快速响应与处理透明",
        },
        {
          title: "变动与盘点管理",
          detail: "管理资产的调拨、借用，并定期盘点确保账实相符",
        },
        {
          title: "报废与退役",
          detail: "规范资产报废流程，完成技术鉴定、审批与财务销账",
        },
      ],
    },
  },
  asset3: {
    til: "技术架构",
    dil: "基于先进技术栈构建，确保系统稳定、安全、高效、安全",
    imgUrl: require("../assets/images/solution/asset/customized0.png").default,
    width: "900px",
  },
  asset4: {
    title: "您企业的资产运维是否正面临这些挑战？",
    detail: "行业背景与挑战",
    contentList: [
      {
        til: "资产盘清难题",
        list: [
          "台账缺失：原始记录零散，资产流转轨迹无法追溯",
          `流程缺失：未建立标准管理流程，资产数据"失真"`,
        ],
      },
      {
        til: "资产盘活困境",
        list: [
          "资产统筹：账实不符，分配不合理",
          `应用统筹：难以匹配部门需求，共享复用困难`,
        ],
      },
      {
        til: "资产增值挑战",
        list: [
          "利用率低：闲置资产难以识别和调整",
          "寿命缩短：隐性流失，提前损耗",
        ],
      },
    ],
  },
  asset5: {
    title: "“惠联码上修”™ · 一站式解决所有问题",
    contentList: [
      {
        til: "“惠联码上修”™",
        til2: "信息化管理平台",
        detail:
          "实现对办公设备资产信息、维修人员信息及运维服务数据的实时动态采集，构建海量数据资源库，建立完整的办公资产全生命周期管理体系。",
      },
      {
        til: "“惠联码上修”™",
        til2:  "· APP",
        detail:
          "专为资产信息化管理打造的便捷应用程序，提供高效、智能的移动化智慧工具，支持维修人员工单处理、资产信息管理和报修处理。",
      },
      {
        til: "“惠联码上修”™",
        til2: "· 小程序",
        detail:
          "用户可通过扫描设备专属二维码或手动输入设备编号，快速提交报修请求，填写故障描述并上传照片，维修完成后可对服务进行评价。",
      },
    ],
  },
  asset6: {
    title: "“惠联码上修”™ · 智能报修管理系统",
    content1: {
      title1: "设备管理",
      title2: "办公资产管理平台",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement1.png")
        .default,
      list: [
        {
          title: "办公资产管理",
          detail: "从采购、入库、使用、维护到报废的完整管理流程",
        },
        {
          title: "批量导入与导出",
          detail: "支持Excel批量导入设备信息，导出资产报表",
        },
        {
          title: "报修码生成与打印",
          detail: "为每台设备生成唯一报修二维码，一键报修",
        },
        {
          title: "设备健康度评估",
          detail: "基于历史数据自动评估设备健康状态，提前预警",
        },
      ],
    },
    content2: {
      title1: "工单管理",
      title2: "工单全流程管理",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement2.png")
        .default,
      imgUrl2:
        require("../assets/images/solution/asset/warrantyManagement2-2.png")
          .default,
      detail:
        "工单管理其中包括：工单量统计、新建工单、批量导入工单、查看工单详情，打印工单表等功能。",
      list: ["创建工单", "处理工单", "分配工单", "完成工单"],
    },
    content3: {
      title1: "工分分析",
      title2: "工分计算与绩效评估",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement3.png")
        .default,
      imgUrl2:
        require("../assets/images/solution/asset/warrantyManagement3-2.png")
          .default,
      list: [
        {
          tit: "工分计算规则",
          detList: [
            "基础工分：根据工单类型和难度设定",
            "时效奖励：提前完成额外加分",
            "满意度奖励：客户评价优秀额外加分",
            "复杂任务奖励：解决复杂问题额外加分",
          ],
        },
        {
          tit: "绩效激励体系",
          detList: [
            "月度工分排名奖励",
            "季度优秀工程师评选",
            "年度服务之星表彰",
            "技能提升培训机会",
          ],
        },
      ],
    },
    content4: {
      title1: "移动端APP",
      title2: "移动端App功能特点",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement4.png")
        .default,
      list: [
        {
          title: "工单实时接收与处理",
          detail: "工程师随时随地接收工单，实时更新处理状态",
        },
        {
          title: "设备信息查询",
          detail: "快速查询设备详情、历史维修记录和保修信息",
        },
        {
          title: "扫码报修",
          detail: "扫描设备报修码，一键发起报修申请",
        },
        {
          title: "绩效查询",
          detail: "工程师可随时查询自己的工分和绩效排名",
        },
        {
          title: "知识库",
          detail: "内置常见问题解决方案和维修指南",
        },
      ],
    },
    titList: ["设备管理", "工单管理", "工分分析", "移动端APP"],
  },
  asset7: {
    title: "技术资质保护",
    detail: "专业认证，值得信赖",
    tabsName: "专业认证",
    iconUrl: require("../assets/images/solution/asset/iconurl.png").default,
    contentList: [
      "高新技术企业、专精特新企业认证",
      "已通过信息安全管理体系认证",
      " 拥有43项软件著作权登记",
      "深耕行业20余年，具有高水准服务水平",
    ],
    pList: [
      "深耕办公设备服务行业二十余年，我们积累了丰富的经验和专业知识， 能够为各类企业提供最优质的资产管理解决方案。",
      "我们的团队由行业专家组成，致力于通过技术创新和服务优化， 帮助企业降低成本、提高效率，实现办公资产的智能化管理。",
    ],
    cardList: [
      {
        title: "50+",
        detail: "软件著作权",
      },
      {
        title: "20+",
        detail: "行业积累",
      },
    ],
  },
};
const successOperations = {
  title: "成功案例",
  detail: [
    "探索我们如何为各行各业客户创造真实价值",
    "以专业解决方案，助力客户实现数字化转型",
  ],
  beforeContent: {
    top: "欢迎来到案例展示平台",
    bottom: [
      "探索我们如何为各行各业客户创造真实价值",
      "以专业解决方案，助力客户实现数字化转型",
    ],
    btn:"查看案例"
  },
};
const aboutUs = {
  space_part1: {
    title: "欢迎来到上海惠联办公设备有限公司",
    detail: "一站式智慧办公解决方案提供商，让办公更简单、更智能、更高效",
    btnText: "立即体验",
  },
  space_part2: {
    title: "关于惠联",
    list: [
      {
        itemTitle: "地址",
        itemContent: "上海市奉贤区金汇镇乐善村木行542号",
        iconUrl: require("../assets/images/aboutUs/icon1.png").default,
      },
      {
        itemTitle: "邮箱",
        itemContent: "huilian118@163.com",
        iconUrl: require("../assets/images/aboutUs/icon2.png").default,
      },
      {
        itemTitle: "电话",
        itemContent: "021-57186429",
        iconUrl: require("../assets/images/aboutUs/icon3.png").default,
      },
      {
        itemTitle: "营业时间",
        itemContent: "周一至周五: 9:00 - 18:00",
        iconUrl: require("../assets/images/aboutUs/icon4.png").default,
      },
    ],
    describeTitle: "访问我们",
    describeContent: "欢迎前来参观我们的企业，实现共赢",
    learnMore: "了解更多",
    imgUrl: require("../assets/images/aboutUs/img.png").default,
  },
};
const onlineExperience = {
  title: "在线体验",
  con1: "公司名称",
  con1Reminder: "请填写公司名称",
  con2: "行业类型",
  con3: "联系人姓名",
  con3Reminder: "请填写联系人姓名",
  con4: "联系人电话",
  con4Reminder: "请填写联系人电话",
  con4Reminder1: "请输入正确手机号",
  con5: "所属城市",
  sub: "提交申请",
};

export default {
  home,
  productList,
  navigation,
  solution_archives,
  spaceOperations,
  solution_infoServices,
  residency,
  solution_asset,
  successOperations,
  aboutUs,
  onlineExperience,
};
